<template>
  <div class="feet-r">
    <el-button
      icon="el-icon-download"
      size="small"
      type="primary"
      @click="operationBtn"
    >{{ $t('receivablePayable.DownloadTheTemplate') }}</el-button>
    <upload-excel
      :on-success="importLogistics"
      :but-name="$t('CenterForSorting.Import')"
    />
  </div>
</template>

<script>
import { apiGetInlandTransportationFeeImport } from '@/api/finance/basicData';
import { saveAs } from 'file-saver';
const ExcelJS = require('exceljs');
import uploadExcel from '@/components/UploadExcel';

export default {
  name: 'ImportFee',
  components: {
    uploadExcel
  },
  data() {
    return {
      errData: []
    };
  },
  methods: {
    // 下载模板
    operationBtn() {
      const that = this;
      async function ddd() {
        const wb = new ExcelJS.Workbook();
        const Sheet1 = wb.addWorksheet('Sheet1');
        Sheet1.columns = [
          {
            header: '州名',
            key: 'twoCode',
            width: 40
          },
          {
            header: '城市名',
            key: 'cityName',
            width: 40
          },
          {
            header: '收件人邮编',
            key: 'zipCode',
            width: 50
          }
        ];
        Sheet1.getCell('A2').value = 'Estado';
        Sheet1.getCell('B2').value = 'Cidade';
        Sheet1.getCell('C2').value = 'Código postal do destinatário';
        Sheet1.getRow(1).font = {
          color: { argb: '000000' },
          bold: true
        };
        Sheet1.getRow(2).font = {
          color: { argb: '000000' },
          bold: true
        };
        Sheet1.mergeCells('A3:C3');
        Sheet1.getCell('A3').value = `注意：全部必填；其中收件人邮编（，邮编号码段连接符“~”，比如：1001~2001，代表1001到2001之间全部1000个邮编号码；邮编号码段之间通过英文逗号隔开，例如1001~2001,3001~4001）
Observação: Todos os campos são obrigatórios. O intervalo de códigos postais do destinatário é indicado pelo hífen “~” (por exemplo, 1001~2001 representa todos os 1.000 códigos postais entre 1001 e 2001). Separe os intervalos de códigos postais usando vírgulas, por exemplo, 1001~2001,3001~4001.`;
        Sheet1.getRow(3).height = 80;
        Sheet1.getRow(3).getCell(1).style = {
          font: {
            color: { argb: 'ff0000' }
          },
          alignment: {
            vertical: 'bottom', // 垂直居中
            horizontal: 'left', // 水平左对齐
            wrapText: true, // 自动换行
            indent: 0 // 禁止缩进
          }
        };
        const buffer = await wb.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: 'application/octet-stream'
        });
        const saveName = that.$t('receivablePayable.ImportAddCharges') + '.xlsx';
        saveAs(blob, saveName);
      }
      ddd();
    },
    // 导入费用
    importLogistics(array) {
      const dataArr = [];
      const arrData = array[0].results.slice(2);
      const logisticsKey = {
        '州名': 'twoCode',
        '城市名': 'cityName',
        '收件人邮编': 'zipCode'
      };
      arrData.map((item) => {
        const dataObj = {};
        for (const k in logisticsKey) {
          if (item[k]) {
            dataObj[logisticsKey[k]] = item[k];
          } else {
            dataObj[logisticsKey[k]] = '';
          }
        }
        dataArr.push(dataObj);
      });
      console.log(dataArr, '导入费用');
      apiGetInlandTransportationFeeImport({ 'list': dataArr }).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('basicData.TheOperationSucceeded'));
          this.$emit('importChange');
        }
      });
    }
  }
};
</script>
